import {connect} from "react-redux";
import App from "../components/App";
import * as ChatActions from '../store/actions/chatActions';
import * as VideoActions from '../store/actions/videoActions';
import * as AuthActions from '../store/actions/authActions';
import * as AdminActions from '../store/actions/adminActions';
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.chat,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    addMessage: (message) => {
        dispatch(ChatActions.addMessage(message));
    },
    addedCuNote: (message) => {
        dispatch(AdminActions.addedCuNote(message));
    },
    editedCuNote: (message) => {
        dispatch(AdminActions.editedCuNote(message));
    },
    deletedCuNote: (message) => {
        dispatch(AdminActions.deletedCuNote(message));
    },
    prependMessages: (messages) => {
        dispatch(ChatActions.prependMessages(messages));
    },
    initChat: (profileId, token) => {
        dispatch(ChatActions.getUsers(profileId, token));
        dispatch(ChatActions.getThreads(profileId, token));
    },

    threadCreated: (thread, redirect) => {
        dispatch(ChatActions.threadCreated(thread, redirect));
    },
    setIsTyping: (data) => {
        dispatch(ChatActions.setIsTyping(data));
    },
    setSeen: (data) => {
        dispatch(ChatActions.setSeen(data));
    },
    setInitialThreads: (threads, token) => {
        dispatch(ChatActions.setInitialThreads(threads, token));
    },
    handleStatusChange: (data, profileId) => {
        dispatch(ChatActions.handleStatusChange(data, profileId));
    },
    loadedThreadFiles: (data) => {
        dispatch(ChatActions.loadedThreadFiles(data));
    },
    threadUpdated: (thread, profileId) => {
        dispatch(ChatActions.threadUpdated(thread, profileId));
    },
    ticketSolved: (thread, profileId) => {
        dispatch(ChatActions.ticketSolved(thread, profileId));
    },
    ticketClosed: (thread, profileId) => {
        dispatch(ChatActions.ticketClosed(thread, profileId));
    },
    threadFieldUpdated: (thread) => {
        dispatch(ChatActions.threadFieldUpdated(thread));
    },
    messageUpdated: (thread) => {
        dispatch(ChatActions.messageUpdated(thread));
    },
    loadedReportedComments: (data) => {
        dispatch(ChatActions.loadedReportedComments(data));
    },
    resolveReport: (data) => {
        dispatch(ChatActions.resolveReport(data));
    },
    deleteAttachment: (data) => {
        dispatch(ChatActions.deleteAttachment(data));
    },
    loadedAttachments: (data) => {
        dispatch(ChatActions.loadedAttachments(data));
    },
    loadedInstructors: (data) => {
        dispatch(ChatActions.loadedInstructors(data));
    },
    announcementAdded: (data) => {
        dispatch(ChatActions.announcementAdded(data));
    },
    loadedAnnouncements: (data) => {
        dispatch(ChatActions.loadedAnnouncements(data));
    },
    announcementDeleted: data => {
        dispatch(ChatActions.announcementDeleted(data));
    },
    settingsUpdated: data => {
        dispatch(ChatActions.settingsUpdated(data));
    },
    addToUnreadCount: (threadId) => {
        dispatch(ChatActions.addToUnreadCount(threadId));
    },
    resetUnread: (threadId) => {
        dispatch(ChatActions.resetUnread(threadId));
    },
    updateCourseNotifications: (data) => {
        dispatch(VideoActions.updateCourseNotifications(data));
    },
    initialTasks: (tasks) => {
        dispatch(AuthActions.setInitialTasks(tasks));
    },
    updateCourseStatus: (courseStatus) => {
        dispatch(VideoActions.updateCourseStatus(courseStatus));
    },
    updateFlags: (data) => {
        dispatch(VideoActions.updateFlags(data));
    },
    updateTask: (data) => {
        dispatch(AuthActions.updateTask(data));
    },
    addTask: (data) => {
        dispatch(AuthActions.addTask(data));
    },
    addDiscussion: (comment) => {
        dispatch(VideoActions.postedDiscussion(comment));
    },
    addComment: (comment) => {
        dispatch(VideoActions.postedComment(comment));
    },
    deleteLike: (like) => {
        dispatch(VideoActions.deletedLike(like));
    },
    postLike: (like) => {
        dispatch(VideoActions.postedLike(like));
    },
    deleteFollow: (follow) => {
        dispatch(VideoActions.deletedFollow(follow));
    },
    postFollow: (follow) => {
        dispatch(VideoActions.postedFollow(follow));
    },
    updateCourseUser: (cu) => {
        dispatch(VideoActions.editedCourseUser(cu));
    },
    updateAdminCourseUser: (cu) => {
        dispatch(AdminActions.editedCourseUser(cu));
    },
    updatedAdminUserLecture: (ul) => {
        dispatch(AdminActions.updatedUserLecture(ul));
    },
    updatedUserLecture: (ul) => {
        dispatch(VideoActions.updatedUserLecture(ul));
    },
    addedAdminUserLecture: (ul) => {
        dispatch(AdminActions.addedUserLecture(ul));
    },
    addedUserLecture: (ul) => {
        dispatch(VideoActions.addedUserLecture(ul));
    },
    removedAdminUserLecture: (ul) => {
        dispatch(AdminActions.removedUserLecture(ul));
    },
    removedUserLecture: (ul) => {
        dispatch(VideoActions.removedUserLecture(ul));
    },
    deletedAdminQuiz: (ul) => {
        dispatch(AdminActions.removedQuiz(ul));
    },
    deletedQuiz: (ul) => {
        dispatch(VideoActions.removedQuiz(ul));
    },
    logout: () => {
        dispatch(AuthActions.logoutUserAction())
    },
    takeTour: (profile, token) => {
        dispatch(AuthActions.updateProfile(profile, token));
    }
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(App));


// WEBPACK FOOTER //
// ./src/containers/AppContainer.js